import { ILayoutProps } from "src/types/main";

export default function RealEstateLayout({ children }: ILayoutProps) {
  return <div className="realestate">{children}</div>
}
